import { makeStyles, withStyles, Tooltip } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import StarRatings from 'react-star-ratings';
import PriceToStr from '../../../_components/PriceToStr';
import DiscountModal from '../../../views/ProductList/components/DiscountModal/DiscountModal';
import AddToCartDialog from '../../ProductList/components/AddToCartDialog/AddToCartDialog';
import connect from 'react-redux/es/connect/connect';
import { cartActions, customerActions } from '../../../_actions';
import clsx from 'clsx';
import { getCurrencyContrData } from '../../../_helpers';
import { authentication } from '../../../_reducers/authentication.reducer';
import { Link } from 'react-router-dom';
import Details from './Details';
import expectedDate from '../../../images/expected_date_icon_1-01.svg';
import moment from 'moment';
import RadioButtonUnchecked from '@material-ui/core/SvgIcon/SvgIcon';
import IconBoxDeal from '../../../images/IconBoxDeal.svg';
// import components
import OfferPriceDialog from './OfferPriceDialog';
// import fetch
import axInst from '../../../_helpers/axios-instance';

const useStyles = makeStyles(() => ({
  regularPriceHolder: {
    display: 'block',

    '& em': {
      display: 'block',
      // width: '100%',
    },
  },
  expected_dateBlock: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  expected_date_img_holder: {
    width: '200px',
    position: 'relative',

    "& img": {
      height: '20px',
    }
  },

  stBlockDeliveryRadioOrange: {
    fontSize: 12,
    borderRadius: '50%',
    backgroundColor: 'orange',
    color: 'orange',
    margin: '0 0 0 10px'
  },
}));
const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',

    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const DetailProductInfo = props => {
  const {
    result,
    currencyMain,
    promotionsByProductsList,
    addToCart,
    main_currency,
    sell_currency_id,
    customer_data,
    wish_list,
    addToWishlist,
    removeFromWishlist,
    promoProductsCount,
    promoDataLoading,
    promotions,
    reviewIsActive,
    tabsRef,
    customer_id,
    lastItemBreadcrumb,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const [dialogData, setDialogData] = useState({});
  const [showSingleProductList, setShowSingleProductList] = useState(true);
  const [discountsModal, setDiscountsModal] = useState(false);
  const [offerDialog, setOfferDialog] = useState({});
  let otherCustomersList = [];

  useEffect(() => {
    if (result?.bread_crumb?.[1]?.bread_crumb_name == "Електротранспорт") {
      const checkRegisterUser = JSON.parse(window.localStorage.getItem('state'));
      if (checkRegisterUser?.authentication?.loggedIn) {
        setShowSingleProductList(true);
      } else {
        setShowSingleProductList(false);
      }
    }
  }, [result])

  const row = {
    brand: result.article.brand,
    brand_clean: result.article.brand_clean,
    brand_orig_clean: result.article.brand_clean,
    article: result.article.article,
    article_clean: result.article.article_clean,
    article_orig_clean: result.article.article_clean,
    images: {
      thumb: result.article.photo.thumb,
      // gallery: result.article.photo.gallery_photos,
      // art: result.article.photo.art_photos,
      // large: result.article.photo.large_photos,
      // mobile: result.article.photo.mobile_photos,
    },
    //balance: result.on_stock,
    //balance: result.on_stock,tion
    price: result.on_stock[0].price,
    /*priceCurrent: currencyMain && currencyMain.simbol === "₴"
        ? Math.round(result.on_stock[0].price * currencyMainContr.koef)
        : result.on_stock[0].price * currencyMainContr.koef,*/
    priceCurrent: result.on_stock[0].priceCurrent,
    name: result.article.name,
    product_id: result.article.product_id,
  };
  if (
    promotionsByProductsList &&
    promotionsByProductsList[row.product_id] !== undefined
  )
    row.promoLabel = promotionsByProductsList[row.product_id];
  if (result.isRequest === 1) row.offers = result.on_stock;
  else row.balance = result.on_stock;

  const discounts_by_quantity_sum_of_order =
    result.on_stock[0].discounts_by_quantity_sum_of_order;

  const discountByQuantityExist =
    discounts_by_quantity_sum_of_order !== undefined &&
    discounts_by_quantity_sum_of_order.discounts_by_product !== undefined;
  const currencyMainContr = getCurrencyContrData(
    currencyMain,
    main_currency,
    sell_currency_id,
    customer_data,
  );
  const customer_group_id = customer_data && customer_data.discount_group_id;

  const handleAddToCart = () => {
    setDialogData({
      row,
      indexRows: '',
      type: '',
    });
  };
  useEffect(() => {
    otherCustomerMinPrice();
  }, []);
  let guarantees = [];
  guarantees['Дн'] = t('common:warranty_d');
  guarantees['Мес'] = t('common:warranty_m');
  guarantees['Г'] = t('common:warranty_y');

  const otherCustomerMinPrice = () => {
    if (result.prices_by_customer.other_customers.length > 0) {

      result.prices_by_customer.other_customers.map((el, index) => {
        if (
          el.discount_group__id !== 84 &&
          el.discount_group__id !== 81 &&
          el.discount_group__id !== 87 &&
          el.discount_group__id !== 78 &&
          el.discount_group__id !==
          result?.prices_by_customer?.current_customer?.discount_group__id
        ) {
          otherCustomersList.push(el);
        }
        return otherCustomersList;
      });
      let minPriceOtherCustomerArr = [];
      let minPriceOtherCustomer;
      let minPriceOtherCustomerName;
      if (otherCustomersList?.length > 0) {
        otherCustomersList.map((el, index) => {
          return minPriceOtherCustomerArr.push(
            el?.currency_of_contract_price.price_discount,
          );
        });

        minPriceOtherCustomer = Math.min(...minPriceOtherCustomerArr);
        minPriceOtherCustomerName = otherCustomersList.filter(
          otherCustomersList =>
            otherCustomersList?.currency_of_contract_price?.price_discount ===
            minPriceOtherCustomer,
        );
        let parsePriceGroup = minPriceOtherCustomerName[0]?.discount_group__name.split(
          ';',
        );

        return (
          <>
            <div style={{ lineHeight: '1', fontSize: '13px', color: '#606060' }}>
              {parsePriceGroup[1]}:
            </div>
            <PriceToStr
              stSumma={{
                fontSize: '13px',
                fontStyle: 'normal',
                color: '#606060',
              }}
              data={minPriceOtherCustomer}
              beforeText={''}
              text={
                otherCustomersList[0] &&
                  otherCustomersList[0]?.currency_of_contract_price.currency
                    .simbol
                  ? otherCustomersList[0]?.currency_of_contract_price.currency
                    .simbol
                  : ''
              }
              grn={t('common:uah')}
            />
          </>
        );
      }
    }
  };

  const renderTooltip = () => {
    let findRepeatDiscountGroupId = result?.prices_by_customer?.other_customers;
    if (findRepeatDiscountGroupId.length > 0) {
      let current_customer_discount_group_id =
        result.prices_by_customer?.current_customer.discount_group__id;
      let resultMinPrice = [];
      let minPrice = 0;
      let saveCustomerMinPrice;
      let unique = [];
      let g = [];
      let repeatDiscountGroupIdPrice = [];

      findRepeatDiscountGroupId.map((el, index) => {
        if (el?.discount_group__id !== current_customer_discount_group_id) {
          g.push(el?.discount_group__id);
        }
        return true;
      });

      let h = g.reduce((x, y) => (x.includes(y) ? x : [...x, y]), []);

      h.map((el, index) => {
        unique.push(
          findRepeatDiscountGroupId.filter(
            findRepeatDiscountGroupId =>
              findRepeatDiscountGroupId?.discount_group__id === el,
          ),
        );
        return true;
      });

      unique.map((el, index) => {
        repeatDiscountGroupIdPrice = [];
        el.map((elem, index) => {
          repeatDiscountGroupIdPrice.push(
            elem.current_currency_price.price_discount,
          );
          minPrice = Math.min(...repeatDiscountGroupIdPrice);
          return true;
        });

        saveCustomerMinPrice = el.filter(
          el => el.current_currency_price.price_discount === minPrice,
        );

        resultMinPrice.push({
          price:
            saveCustomerMinPrice[0].currency_of_contract_price.price_discount,
          name: saveCustomerMinPrice[0].discount_group__name,
          currency_of_contract: saveCustomerMinPrice[0].currency_of_contract,
          currency_of_contract_price:
            saveCustomerMinPrice[0].currency_of_contract_price.currency.simbol,
          discount_group__id: saveCustomerMinPrice[0].discount_group__id,
        });

        return true;
      });

      return (
        <ul className={classes.list_other_customer_price}>
          <li>
            <span>
              {result.prices_by_customer.current_customer.discount_group__name}
            </span>
            <span>
              <span style={{ margin: '0 5px 0 0' }}>
                {result.prices_by_customer.current_customer.currency_of_contract_price.price_discount.toFixed(
                  2,
                )}
              </span>
              <span>
                {result.prices_by_customer.current_customer
                  .currency_of_contract === 'UAH'
                  ? t('common:uah')
                  : result.prices_by_customer.current_customer
                    .currency_of_contract_price.currency.simbol}
              </span>
            </span>
          </li>
          {resultMinPrice.map((elem, index) => (
            <li key={elem.name + index}>
              <span>{elem.name}</span>
              <span>
                <span style={{ margin: '0 5px 0 0' }}>
                  {elem.price.toFixed(2)}
                </span>
                <span>
                  {elem.currency_of_contract === 'UAH'
                    ? t('common:uah')
                    : elem.currency_of_contract_price}
                </span>
              </span>
            </li>
          ))}

          {findRepeatDiscountGroupId.map((el, index) => (
            <>
              {el.discount_group__id !== current_customer_discount_group_id &&
                el.discount_group__id !== resultMinPrice[0].discount_group__id &&
                el.discount_group__id !== resultMinPrice[1].discount_group__id ? (
                <li key={index} color="inherit">
                  <span>{el.discount_group__name}</span>
                  <span>
                    <span style={{ margin: '0 5px 0 0' }}>
                      {el.currency_of_contract_price.price_discount.toFixed(2)}
                    </span>
                    <span>
                      <span>
                        {el.currency_of_contract === 'UAH'
                          ? t('common:uah')
                          : el.currency_of_contract_price.currency.simbol}
                      </span>
                    </span>
                  </span>
                </li>
              ) : null}
            </>
          ))}
        </ul>
      );
    }
  };

  const handleClose = props => {
    const { offers, localMainCartId } = props;
    if (offers) {
      Object.keys(offers).map(
        key =>
          offers[key].quantity > 0 &&
          addToCart(
            localMainCartId,
            key,
            offers[key].price,
            offers[key].quantity,
          ),
      );
    }
    setDialogData({});
  };

  const handleLike = (event, data) => {
    event.preventDefault();
    if (wish_list.find(i => i.article === data.article)) {
      removeFromWishlist(data);
      axInst.post("/api/delete-wish-list-product/", JSON.stringify({ customer_id: customer_id, article: row.article }))
    } else {
      addToWishlist(data);
      axInst.post("/api/add-wish-list-product/", JSON.stringify({ customer_id: customer_id, article: row.article }))
    }
  };

  const handleOfferDialog = (product_id) => {
    setOfferDialog({
      customer_id: customer_id,
      product_id: product_id,
    })
  };

  const onCloseOfferDialog = () => {
    setOfferDialog({});
  };

  const getBaseUnitPrice = () => {
    const stock = result?.on_stock?.[0];
    if (!stock) return 0;

    // те, що ти показуєш як основну ціну товару
    if (stock.priceCurrent != null) return Number(stock.priceCurrent);
    if (stock.price != null) return Number(stock.price);

    return 0;
  };

  const calcProfitForQuantityDiscount = (listItem) => {
    if (!listItem) return 0;

    const baseUnitPrice = getBaseUnitPrice();
    const qty = Number(listItem.quantity) || 0;
    const discountedUnitPrice = Number(listItem.price_with_discount) || 0;

    if (!baseUnitPrice || !qty || !discountedUnitPrice) return 0;

    const diff = baseUnitPrice - discountedUnitPrice;
    if (diff <= 0) return 0; // немає реальної вигоди

    return diff * qty;
  };

  const isSpecialPromotion = promotions && Number(promotions.id) === 42;


  return (
    <>
      <div
        className={clsx(
          ' col-lg-7 col-12 mb-md-0 mb-3',
          promoProductsCount <= 0 && !promoDataLoading
            ? 'col-xxl-8'
            : 'col-xxl-5',
        )}>
        <div className="single-product-block info">
          <div style={{ padding: '0 0 10px 0'}}>
            <div className="single-product-flex mb-3">
              <h2 className="single-product-title">
                {result.article?.brand}
                <span className="single-product-like"></span>
              </h2>
              <div className="single-product-code">
                {result.article.article}
              </div>
            </div>

            <div className="single-product-flex" style={{ flexWrap: 'wrap' }}>
              <p className="single-product-desc">{result.article.name}</p>
              {/* Нужно будет убрать условие <<result.article.reviews_amount>> для того что бы показывало 0 отзывов 0 звезд, а пока просто скрыли */}
              {result.article.reviews_amount > 0 && (
                <div
                  onClick={() => {
                    tabsRef.current.scrollIntoView({ behavior: 'smooth' });
                    reviewIsActive.current = true;
                  }}>
                  <Link
                    to="#top"
                    className="single-product-stars  d-flex gap-10">
                    <StarRatings
                      rating={result.article.average_rating}
                      starDimension="19px"
                      starSpacing="2.25px"
                      starRatedColor="#FFBE00"
                    />
                    {result.article.reviews_amount || 0} {t('common:reviews')}
                  </Link>
                </div>
              )}
            </div>
            <div className="single-product-btns">
              <Tooltip
                title={
                  t('common:Country') + ':' + result.article.brands_country
                }>
                <button className="btn btn-single-product px-2">
                  <div className="button-icon">
                    <svg
                      width="13"
                      height="16"
                      viewBox="0 0 13 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1 6.83333C1 3.625 3.625 1 6.83333 1C10.0417 1 12.6667 3.625 12.6667 6.83333C12.6667 11.15 7.35833 14.7667 7.18333 14.8833C7.06667 14.9417 6.95 15 6.83333 15C6.71667 15 6.6 14.9417 6.48333 14.8833C6.30833 14.7667 1 11.15 1 6.83333ZM2.16699 6.83268C2.16699 9.98268 5.72533 12.8993 6.83366 13.716C7.94199 12.8993 11.5003 9.98268 11.5003 6.83268C11.5003 4.26602 9.40033 2.16602 6.83366 2.16602C4.26699 2.16602 2.16699 4.26602 2.16699 6.83268ZM6.83333 4.5C5.55 4.5 4.5 5.55 4.5 6.83333C4.5 8.11667 5.55 9.16667 6.83333 9.16667C8.11667 9.16667 9.16667 8.11667 9.16667 6.83333C9.16667 5.55 8.11667 4.5 6.83333 4.5ZM5.66699 6.83268C5.66699 7.47435 6.19199 7.99935 6.83366 7.99935C7.47533 7.99935 8.00033 7.47435 8.00033 6.83268C8.00033 6.19102 7.47533 5.66602 6.83366 5.66602C6.19199 5.66602 5.66699 6.19102 5.66699 6.83268Z"
                        fill="#414D5F"
                      />
                      <path
                        d="M7.18333 14.8833L7.2284 14.9735L7.2388 14.9665L7.18333 14.8833ZM6.48333 14.8833L6.42743 14.9672L6.43861 14.9728L6.48333 14.8833ZM6.83366 13.716L6.77434 13.7965L6.83366 13.8402L6.89298 13.7965L6.83366 13.716ZM6.83333 0.9C3.56977 0.9 0.9 3.56977 0.9 6.83333H1.1C1.1 3.68023 3.68023 1.1 6.83333 1.1V0.9ZM12.7667 6.83333C12.7667 3.56977 10.0969 0.9 6.83333 0.9V1.1C9.98644 1.1 12.5667 3.68023 12.5667 6.83333H12.7667ZM7.2388 14.9665C7.32971 14.9059 8.70765 13.9676 10.064 12.5012C11.4176 11.0379 12.7667 9.0306 12.7667 6.83333H12.5667C12.5667 8.95273 11.2616 10.9121 9.91721 12.3654C8.57569 13.8157 7.21196 14.7441 7.12786 14.8001L7.2388 14.9665ZM6.83333 15.1C6.9782 15.1 7.11719 15.0282 7.22805 14.9728L7.13861 14.7939C7.01614 14.8551 6.9218 14.9 6.83333 14.9V15.1ZM6.43861 14.9728C6.54947 15.0282 6.68847 15.1 6.83333 15.1V14.9C6.74487 14.9 6.65053 14.8551 6.52805 14.7939L6.43861 14.9728ZM0.9 6.83333C0.9 9.0306 2.24906 11.0379 3.60263 12.5012C4.95902 13.9676 6.33696 14.9059 6.42786 14.9665L6.5388 14.8001C6.45471 14.7441 5.09098 13.8157 3.74945 12.3654C2.40511 10.9121 1.1 8.95273 1.1 6.83333H0.9ZM6.89298 13.6355C6.34229 13.2297 5.18244 12.3017 4.1613 11.0851C3.138 9.86581 2.26699 8.37201 2.26699 6.83268H2.06699C2.06699 8.44336 2.97515 9.98289 4.0081 11.2136C5.04321 12.447 6.2167 13.3856 6.77434 13.7965L6.89298 13.6355ZM11.4003 6.83268C11.4003 8.37201 10.5293 9.86581 9.50602 11.0851C8.48488 12.3017 7.32503 13.2297 6.77434 13.6355L6.89298 13.7965C7.45062 13.3856 8.6241 12.447 9.65921 11.2136C10.6922 9.98289 11.6003 8.44336 11.6003 6.83268H11.4003ZM6.83366 2.26602C9.3451 2.26602 11.4003 4.32124 11.4003 6.83268H11.6003C11.6003 4.21079 9.45555 2.06602 6.83366 2.06602V2.26602ZM2.26699 6.83268C2.26699 4.32124 4.32222 2.26602 6.83366 2.26602V2.06602C4.21176 2.06602 2.06699 4.21079 2.06699 6.83268H2.26699ZM4.6 6.83333C4.6 5.60523 5.60523 4.6 6.83333 4.6V4.4C5.49477 4.4 4.4 5.49477 4.4 6.83333H4.6ZM6.83333 9.06667C5.60523 9.06667 4.6 8.06144 4.6 6.83333H4.4C4.4 8.1719 5.49477 9.26667 6.83333 9.26667V9.06667ZM9.06667 6.83333C9.06667 8.06144 8.06144 9.06667 6.83333 9.06667V9.26667C8.1719 9.26667 9.26667 8.1719 9.26667 6.83333H9.06667ZM6.83333 4.6C8.06144 4.6 9.06667 5.60523 9.06667 6.83333H9.26667C9.26667 5.49477 8.1719 4.4 6.83333 4.4V4.6ZM6.83366 7.89935C6.24722 7.89935 5.76699 7.41912 5.76699 6.83268H5.56699C5.56699 7.52958 6.13676 8.09935 6.83366 8.09935V7.89935ZM7.90033 6.83268C7.90033 7.41912 7.4201 7.89935 6.83366 7.89935V8.09935C7.53055 8.09935 8.10033 7.52958 8.10033 6.83268H7.90033ZM6.83366 5.76602C7.4201 5.76602 7.90033 6.24624 7.90033 6.83268H8.10033C8.10033 6.13579 7.53055 5.56602 6.83366 5.56602V5.76602ZM5.76699 6.83268C5.76699 6.24624 6.24722 5.76602 6.83366 5.76602V5.56602C6.13676 5.56602 5.56699 6.13579 5.56699 6.83268H5.76699Z"
                        fill="#414D5F"
                      />
                    </svg>
                  </div>
                  <div className="button-text">
                    {t('common:Country')}: {result.article.brands_country}
                  </div>
                </button>
              </Tooltip>
              <Tooltip
                title={
                  t('common:warranty') +
                  ': ' +
                  result.article.term +
                  (guarantees[result.article.guarantees]
                    ? guarantees[result.article.guarantees]
                    : result.article.guarantees)
                }>
                <button className="btn btn-single-product px-2">
                  <div className="button-icon">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15 8V7.42727C15 7.04545 14.7455 6.79091 14.3636 6.79091C13.9818 6.79091 13.7273 7.04545 13.7273 7.42727V8C13.7273 11.1818 11.1818 13.7273 8 13.7273C4.81818 13.7273 2.27273 11.1818 2.27273 8C2.27273 4.81818 4.81818 2.27273 8 2.27273C8.82727 2.27273 9.59091 2.46364 10.3545 2.78182C10.6727 2.90909 11.0545 2.78182 11.1818 2.46364C11.3091 2.14545 11.1818 1.76364 10.8636 1.63636C9.97273 1.19091 8.95455 1 8 1C4.11818 1 1 4.11818 1 8C1 11.8818 4.11818 15 8 15C11.8818 15 15 11.8818 15 8ZM14.5546 1.82763C14.8091 1.57308 15.191 1.57308 15.4455 1.82763C15.7 2.08217 15.7 2.46399 15.4455 2.71854L8.4455 9.71854C8.31823 9.84581 8.12732 9.90945 8.00004 9.90945C7.87277 9.90945 7.68186 9.84581 7.55459 9.71854L5.6455 7.80945C5.39095 7.5549 5.39095 7.17308 5.6455 6.91854C5.90004 6.66399 6.28186 6.66399 6.53641 6.91854L8.00004 8.38217L14.5546 1.82763Z"
                        fill="#414D5F"
                      />
                      <path
                        d="M10.3545 2.78182L10.3161 2.87414L10.3174 2.87467L10.3545 2.78182ZM11.1818 2.46364L11.089 2.4265L11.1818 2.46364ZM10.8636 1.63636L10.8188 1.72612L10.8265 1.72921L10.8636 1.63636ZM15.4455 1.82763L15.5162 1.75692L15.4455 1.82763ZM14.5546 1.82763L14.6253 1.89834L14.5546 1.82763ZM15.4455 2.71854L15.5162 2.78925L15.4455 2.71854ZM8.4455 9.71854L8.37479 9.64783L8.4455 9.71854ZM7.55459 9.71854L7.48388 9.78925L7.55459 9.71854ZM5.6455 7.80945L5.57479 7.88016L5.6455 7.80945ZM6.53641 6.91854L6.4657 6.98925L6.53641 6.91854ZM8.00004 8.38217L7.92933 8.45288L8.00004 8.52359L8.07076 8.45288L8.00004 8.38217ZM14.9 7.42727V8H15.1V7.42727H14.9ZM14.3636 6.89091C14.5318 6.89091 14.6642 6.94653 14.7543 7.03662C14.8444 7.12671 14.9 7.25909 14.9 7.42727H15.1C15.1 7.21364 15.0284 7.02784 14.8957 6.8952C14.7631 6.76256 14.5773 6.69091 14.3636 6.69091V6.89091ZM13.8273 7.42727C13.8273 7.25909 13.8829 7.12671 13.973 7.03662C14.0631 6.94653 14.1955 6.89091 14.3636 6.89091V6.69091C14.15 6.69091 13.9642 6.76256 13.8316 6.8952C13.6989 7.02784 13.6273 7.21364 13.6273 7.42727H13.8273ZM13.8273 8V7.42727H13.6273V8H13.8273ZM8 13.8273C11.237 13.8273 13.8273 11.237 13.8273 8H13.6273C13.6273 11.1266 11.1266 13.6273 8 13.6273V13.8273ZM2.17273 8C2.17273 11.237 4.76295 13.8273 8 13.8273V13.6273C4.87341 13.6273 2.37273 11.1266 2.37273 8H2.17273ZM8 2.17273C4.76295 2.17273 2.17273 4.76295 2.17273 8H2.37273C2.37273 4.87341 4.87341 2.37273 8 2.37273V2.17273ZM10.393 2.68951C9.6203 2.36755 8.84347 2.17273 8 2.17273V2.37273C8.81107 2.37273 9.56152 2.55972 10.3161 2.87413L10.393 2.68951ZM11.089 2.4265C10.9857 2.68455 10.6679 2.79946 10.3917 2.68897L10.3174 2.87467C10.6775 3.01872 11.1233 2.87908 11.2747 2.50078L11.089 2.4265ZM10.8265 1.72921C11.0846 1.83243 11.1995 2.15028 11.089 2.4265L11.2747 2.50078C11.4187 2.14063 11.2791 1.69484 10.9008 1.54352L10.8265 1.72921ZM8 1.1C8.94215 1.1 9.94444 1.28857 10.8189 1.72581L10.9084 1.54692C10.001 1.09325 8.96694 0.9 8 0.9V1.1ZM1.1 8C1.1 4.17341 4.17341 1.1 8 1.1V0.9C4.06295 0.9 0.9 4.06295 0.9 8H1.1ZM8 14.9C4.17341 14.9 1.1 11.8266 1.1 8H0.9C0.9 11.937 4.06295 15.1 8 15.1V14.9ZM14.9 8C14.9 11.8266 11.8266 14.9 8 14.9V15.1C11.937 15.1 15.1 11.937 15.1 8H14.9ZM15.5162 1.75692C15.2226 1.46332 14.7775 1.46332 14.4839 1.75692L14.6253 1.89834C14.8408 1.68285 15.1593 1.68285 15.3748 1.89834L15.5162 1.75692ZM15.5162 2.78925C15.8098 2.49565 15.8098 2.05052 15.5162 1.75692L15.3748 1.89834C15.5903 2.11383 15.5903 2.43233 15.3748 2.64783L15.5162 2.78925ZM8.51621 9.78925L15.5162 2.78925L15.3748 2.64783L8.37479 9.64783L8.51621 9.78925ZM8.00004 10.0094C8.15205 10.0094 8.36896 9.9365 8.51621 9.78925L8.37479 9.64783C8.26749 9.75512 8.10258 9.80945 8.00004 9.80945V10.0094ZM7.48388 9.78925C7.63113 9.9365 7.84803 10.0094 8.00004 10.0094V9.80945C7.89751 9.80945 7.73259 9.75512 7.6253 9.64783L7.48388 9.78925ZM5.57479 7.88016L7.48388 9.78925L7.6253 9.64783L5.71621 7.73874L5.57479 7.88016ZM5.57479 6.84783C5.28119 7.14142 5.28119 7.58656 5.57479 7.88016L5.71621 7.73874C5.50072 7.52324 5.50072 7.20474 5.71621 6.98925L5.57479 6.84783ZM6.60712 6.84783C6.31352 6.55423 5.86839 6.55423 5.57479 6.84783L5.71621 6.98925C5.9317 6.77375 6.2502 6.77375 6.4657 6.98925L6.60712 6.84783ZM8.07076 8.31146L6.60712 6.84783L6.4657 6.98925L7.92933 8.45288L8.07076 8.31146ZM14.4839 1.75692L7.92933 8.31146L8.07076 8.45288L14.6253 1.89834L14.4839 1.75692Z"
                        fill="#414D5F"
                      />
                    </svg>
                  </div>
                  <div className="button-text">
                    {t('common:warranty') +
                      ': ' +
                      result.article.term +
                      (guarantees[result.article.guarantees]
                        ? guarantees[result.article.guarantees]
                        : result.article.guarantees)}
                  </div>
                </button>
              </Tooltip>
              <Tooltip title={t('common:Prompt shipment')}>
                <button className="btn btn-single-product px-2">
                  <div className="button-icon">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
                        stroke="#414D5F"
                        strokeWidth="1.4"
                      />
                      <path
                        d="M7.00049 3.22852V7.47733L9.66136 9.22852"
                        stroke="#414D5F"
                        strokeWidth="1.2"
                      />
                    </svg>
                  </div>
                  <div className="button-text">
                    {t('common:Prompt shipment')}
                  </div>
                </button>
              </Tooltip>
            </div>
            <div className="single-product-table mt-3">
              <div
                className={
                  "lists-wrapper" +
                  (isSpecialPromotion ? " lists-wrapper-special" : "")
                }
              >
                <ul
                  className={clsx(
                    'single-product-list pr-3',
                    discountByQuantityExist ? 'half-fill' : '',
                  )}
                  style={{
                    width: showSingleProductList ? '100%' : '100%',
                  }}
                >
                  {result.on_stock.map(listItem => (
                    <li
                      key={listItem.warehouse_id}
                      className={listItem.quantity_int === 0 ? 'empty' : ''}>
                      <span className="title">{listItem.warehouse_name}</span>
                      {listItem.quantity === "0" && listItem.expected_date === '0001-01-01' ?
                        <span className="count">
                          {listItem.quantity} {t('common:pieces')}
                        </span>
                        : listItem.quantity === "0" && listItem.expected_date !== '0001-01-01' ?
                          <div className={classes.expected_dateBlock}>
                            <div className={classes.expected_date_img_holder}
                              style={{ width: discounts_by_quantity_sum_of_order.discounts_by_product !== undefined ? '120px' : '200px' }}>
                              <img src={expectedDate} alt="" style={{ display: 'block', width: '100%', height: 'auto' }} />
                              <div style={{
                                position: 'absolute',
                                right: '0px',
                                top: '-5px',
                                fontSize: '12px',
                                color: '#606060',
                              }}>{moment(listItem.expected_date).format('DD.MM.YY')}</div>
                            </div>
                            <RadioButtonUnchecked className={classes.stBlockDeliveryRadioOrange} />
                          </div>
                          :
                          <span className="count">
                            {listItem.quantity} {t('common:pieces')}
                          </span>
                      }
                    </li>
                  ))}
                </ul>

                {discountByQuantityExist &&
                  discounts_by_quantity_sum_of_order.best_discount
                    .discount_conditions_document__promotion_type !== 'NO_CONDITION' &&
                  discounts_by_quantity_sum_of_order.best_discount
                    .discount_conditions_document__promotion_type !== '' && (
                    <>
                      {discounts_by_quantity_sum_of_order.discounts_by_product.map((type, index) => {
                        const isQtyPromo = type.promotion_type === 'FROM_THE_QUANTITY_OF_GOODS';
                        const isSumPromo = type.promotion_type === 'FROM_THE_SUM_OF_ORDER';

                        // просто для контролю, що ми тут і що за id
                        // console.log('Type in map:', type, 'Promotion ID:', promotions?.id);

                        // якщо це знижка "від кількості", але списку показувати не треба
                        if (isQtyPromo && !showSingleProductList) return null;

                        // 🔹 ВАРІАНТ 1: особливий вигляд, якщо promo id === 42
                        const isSpecialPromo =
                          isQtyPromo && promotions && Number(promotions.id) === 42;

                        if (isSpecialPromo) {
                          return (
                            <div
                              //onClick={() => setDiscountsModal(true)}
                              key={`${type.promotion_type}_special_${index}`}
                              className="single-product-list single-product-list__bg half-fill new_promotion_qty_custom"
                            >
                              {type.discounts.map(listItem => (
                                <div className='new_promotion_qty_custom__wrapper' key={listItem.quantity}>
                                  <div className='new_promotion_qty_custom__left'>
                                    <div className='new_promotion_qty_custom__left_wrap'>
                                      <span className='new_promotion_qty_custom__mark'>
                                        {listItem.quantity} шт/уп
                                      </span>
                                      <img src={IconBoxDeal}/>
                                    </div>
                                    <span className='new_promotion_qty_custom__name1'>
                                      Box Deal
                                    </span>
                                    <span className='new_promotion_qty_custom__name2'>
                                      вигода упаковкою
                                    </span>
                                  </div>
                                  
                                  <div className='new_promotion_qty_custom__right'>
                                    <div className="new_promotion_qty_custom__mark2">
                                      <PriceToStr
                                        stSumma={{
                                          fontStyle: 'normal',
                                          fontSize: 27,
                                          fontWeight: '900',
                                        }}
                                        data={listItem.price_with_discount}
                                        beforeText=""
                                        // text={currencyMain?.simbol || ''}
                                        toFixed={0}
                                        grn={t('common:uah')}
                                      />
                                      <span>
                                        грн{' '}
                                        за шт.
                                      </span>
                                    </div>

                                    <div className="new_promotion_qty_custom__profit">
                                      <span className='new_promotion_qty_custom__name3'>Вигода</span>
                                      <span>
                                        <PriceToStr
                                          stSumma={{
                                            fontStyle: 'normal',
                                            fontSize: 22,
                                            fontWeight: '600',
                                          }}
                                          data={calcProfitForQuantityDiscount(listItem)}
                                          beforeText=""
                                          text={currencyMain?.simbol || ''}
                                          toFixed={0}
                                          grn={t('common:uah')}
                                        />
                                      </span>
                                    </div>
                                  </div>

                                </div>
                              ))}
                            </div>

                          );
                        }

                        // 🔹 ВАРІАНТ 2: звичайний FROM_THE_QUANTITY_OF_GOODS (усі інші, не id 42)
                        if (isQtyPromo) {
                          return (
                            <ul
                              onClick={() => setDiscountsModal(true)}
                              key={`${type.promotion_type}_default_${index}`}
                              className="single-product-list single-product-list__bg half-fill old"
                            >
                              {type.discounts.map(listItem => (
                                <li key={listItem.quantity}>
                                  <span className="multiplication">x{listItem.quantity}</span>
                                  <span className="price">
                                    <PriceToStr
                                      stSumma={{
                                        fontStyle: 'normal',
                                        fontSize: 14,
                                        fontWeight: '600',
                                      }}
                                      data={listItem.price_with_discount}
                                      beforeText=""
                                      text={currencyMain?.simbol || ''}
                                      toFixed={0}
                                      grn={t('common:uah')}
                                    />
                                    {' / '}
                                    {t('common:pieces')}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          );
                        }

                        // 🔹 ВАРІАНТ 3: FROM_THE_SUM_OF_ORDER — як було
                        if (isSumPromo) {
                          return (
                            <ul
                              onClick={() => setDiscountsModal(true)}
                              key={`${type.promotion_type}_${index}`}
                              className="single-product-list single-product-list__bg"
                            >
                              {type.discounts.map((listItem, idx) => (
                                <li key={idx}>
                                  <span className="multiplication">x{listItem.quantity}</span>
                                  <span className="price">
                                    <PriceToStr
                                      stSumma={{
                                        fontStyle: 'normal',
                                        fontSize: 14,
                                        fontWeight: '600',
                                      }}
                                      data={
                                        listItem.discount_conditions_document__sum_of_order
                                      }
                                      beforeText=""
                                    />
                                    <div style={{ display: 'flex' }}>
                                      <PriceToStr
                                        stSumma={{
                                          fontStyle: 'normal',
                                          fontSize: 14,
                                          fontWeight: '600',
                                        }}
                                        data={listItem.price_with_discount}
                                        beforeText=""
                                        text={currencyMain?.simbol || ''}
                                        grn={t('common:uah')}
                                      />
                                      <span className={classes.slash}>{' /'}</span>
                                      <span>{t('common:pieces')}</span>
                                    </div>
                                  </span>
                                </li>
                              ))}
                            </ul>
                          );
                        }

                        return null;
                      })}

                      <DiscountModal
                        result={result.on_stock[0]}
                        currencyMain={currencyMain}
                        openDiscountsModal={discountsModal}
                        setDiscountsModal={setDiscountsModal}
                      />
                    </>
                  )}

              </div>
            </div>
          </div>
          {promotions && (
            <Link to={`/promotion/${promotions?.url}/${promotions?.id}`}>
              <img src={promotions?.product_card_banner[0]} width="100%" />
            </Link>
          )}
          <div className="single-product__offer-price">
            <span className="button-text">{t('common:found_something_cheaper_label')} </span>
            <button className="button-text single-product__offer-price_btn" onClick={() => {
              handleOfferDialog(result.article.product_id)
            }}>{t('common:offer_price_label')}</button>
          </div>
          <div className="single-product__footer">
            <div className="single-product__price-block">
              <div className={classes.regularPriceHolder}>
                {result.isDiscount !== 0 && (
                  <PriceToStr
                    stSumma={{
                      fontStyle: 'normal',
                      fontSize: 12,
                      fontWeight: '500',
                      color: '#777777',
                      textDecoration: 'line-through',
                    }}
                    stAll={{
                      marginBottom: -3,
                      // textAlign: 'right',
                    }}
                    data={result.on_stock[0].regularPrice}
                    beforeText={''}
                    text={
                      currencyMain && currencyMain.simbol
                        ? currencyMain.simbol
                        : ''
                    }
                    grn={t('common:uah')}
                  />
                )}
                {result.on_stock && currencyMain !== undefined && (
                  <PriceToStr
                    stSumma={{
                      fontStyle: 'normal',
                      color: result.isDiscount !== 0 && '#FF5252',
                      fontSize: '28px',
                      fontWeight: 700,
                    }}
                    data={result.on_stock[0].priceCurrent}
                    beforeText={''}
                    text={
                      currencyMain && currencyMain.simbol
                        ? currencyMain.simbol
                        : ''
                    }
                    grn={t('common:uah')}
                  />
                )}
                {/* <HtmlTooltip
                  title={<React.Fragment>{renderTooltip()}</React.Fragment>}>
                  <div className={classes.other_customer_price}>
                    {otherCustomerMinPrice()}
                  </div>
                </HtmlTooltip> */}
              </div>
            </div>
            <div
              className="d-flex items-center gap-10 single-footer-btns"
              style={{ maxWidth: '100%' }}>
              <div
                className={clsx(
                  'like like_product-size table-type',
                  wish_list?.find(
                    i => i.article === result.article.article_clean,
                  )
                    ? 'active'
                    : '',
                )}
                onClick={event =>
                  handleLike(event, {
                    article: result.article.article_clean,
                    brand: result.article.brand,
                  })
                }>
                <svg
                  className="like-default"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.04853 4.15142C0.750873 2.53645 1.85092 1.1375 3.56571 1.00537C5.07558 0.890012 5.82404 2.66858 5.97503 3.00835C5.9767 3.01405 5.98024 3.01906 5.98511 3.02263C5.98997 3.0262 5.9959 3.02813 6.00199 3.02813C6.00809 3.02813 6.01401 3.0262 6.01888 3.02263C6.02374 3.01906 6.02728 3.01405 6.02895 3.00835C6.72997 1.1396 8.00689 1.0599 8.45553 1.01585C9.66343 0.890013 11.2833 1.79817 10.9576 3.91442C10.4917 6.85073 5.97072 10.1667 5.97072 10.1667C5.97072 10.1667 1.63738 7.30796 1.04853 4.15142Z"
                    stroke="#315EFB"
                    strokeWidth="1.6"
                  />
                </svg>
              </div>
              <button
                onClick={() => handleAddToCart()}
                className={clsx(
                  'btn btn-big open__modal',
                  result.on_stock.every(i => i.quantity === '0')
                    ? 'disabled'
                    : '',
                )}
                data-modal="#modal-product">
                <svg
                  className="mr-3"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.304453 0.654591C0.49957 0.454903 0.778008 0.344864 1.05645 0.348731C1.87699 0.348731 2.7225 0.519591 3.41332 0.980841C3.95227 1.33697 4.36184 1.871 4.59633 2.47076C4.72289 2.77803 4.79637 3.10322 4.86 3.42877C5.30719 5.68791 5.75227 7.94776 6.21633 10.2037C6.29121 10.5493 6.47402 10.8844 6.77109 11.0865C7.11879 11.3375 7.55789 11.4237 7.98012 11.4237C9.72738 11.4258 11.475 11.4212 13.2223 11.4258C13.5197 11.0809 13.7602 10.6928 13.9971 10.3053C14.3768 9.68939 14.7104 9.04709 15.0525 8.41006C15.4093 7.75932 15.7127 7.08115 16.0555 6.42303C16.2605 6.03631 16.7295 5.81904 17.1577 5.90729C17.6295 5.9899 17.9975 6.43252 18 6.911V6.97252C17.9845 7.13108 17.9395 7.28576 17.8703 7.42885C17.216 8.79854 16.5414 10.1619 15.7419 11.4535C15.4009 11.99 15.0441 12.5237 14.5948 12.9772C14.3205 13.2497 13.9771 13.5067 13.5714 13.4975C11.707 13.5035 9.84234 13.4993 7.97801 13.4996C7.14656 13.5014 6.30141 13.2873 5.6148 12.8074C4.88426 12.3092 4.37379 11.5161 4.18992 10.6537C3.70934 8.33693 3.25512 6.01486 2.79422 3.69385C2.73727 3.39854 2.64937 3.09338 2.43914 2.86803C2.22469 2.63072 1.90898 2.51787 1.60031 2.46865C1.26105 2.4008 0.891211 2.47674 0.574453 2.31045C0.237656 2.14697 0.0158203 1.79049 0 1.41854V1.34049C0.0189844 1.08561 0.120234 0.834591 0.304453 0.654591Z"
                    fill="#1F1F1F"
                  />
                  <path
                    d="M6.94247 14.2255C7.36645 14.1379 7.81575 14.2339 8.18278 14.4582C8.54629 14.6867 8.82438 15.0527 8.93336 15.4696C9.15661 16.1991 8.79626 17.0464 8.13461 17.4159C7.74122 17.6448 7.25149 17.7228 6.81309 17.5868C6.39016 17.4753 6.01821 17.1905 5.79286 16.8168C5.54465 16.4059 5.46239 15.8852 5.61848 15.4264C5.79004 14.8193 6.32688 14.3464 6.94247 14.2255Z"
                    fill="#1F1F1F"
                  />
                  <path
                    d="M13.1652 14.227C13.5727 14.1415 14.0075 14.2224 14.3658 14.4312C15.0404 14.8088 15.4001 15.6807 15.1512 16.4193C14.9525 17.1358 14.2406 17.6586 13.4999 17.6529C13.0158 17.6512 12.5334 17.436 12.2132 17.0721C11.8936 16.7164 11.7294 16.2238 11.78 15.7471C11.8307 15.2996 12.0557 14.8703 12.4093 14.5884C12.6241 14.4034 12.8913 14.2913 13.1652 14.227Z"
                    fill="#1F1F1F"
                  />
                  <rect
                    x="7.875"
                    y="5.625"
                    width="5.625"
                    height="2.25"
                    rx="1.125"
                    fill="#1F1F1F"
                  />
                </svg>
                {t('common:add_to_basket')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <OfferPriceDialog
        data={offerDialog}
        onClose={onCloseOfferDialog}
      />
      <AddToCartDialog
        isDiscount={result?.isDiscount}
        imageDiscount={promotions && promotions?.product_card_banner[0]}
        currencyMainContr={currencyMainContr}
        currencyMain={currencyMain}
        dialogData={dialogData}
        handleClose={handleClose}
        customerGroupId={customer_group_id}
        authentication={authentication}
        discountsByProduct={
          dialogData.row && dialogData.row.discounts_by_quantity_sum_of_order
            ? dialogData.row.discounts_by_quantity_sum_of_order
            : dialogData.row && dialogData.row.balance[0] !== undefined
              ? dialogData.row &&
              dialogData.row.balance[0].discounts_by_quantity_sum_of_order
              : ''
        }
        lastItemBreadcrumb={lastItemBreadcrumb}
      />
    </>
  );
};
const actionCreators = {
  addToCart: cartActions.addToCart,
  addToWishlist: customerActions.addToWishlist,
  removeFromWishlist: customerActions.removeFromWishlist,
};
const mapState = state => {
  const { currencies, main_currency } = state.frontendData;
  const { customer_id, sell_currency_id, wish_list } = state.userSelectedData;
  const { customer_data } = state.contragentData;

  return {
    currencies,
    main_currency,
    sell_currency_id,
    customer_id,
    customer_data,
    wish_list,
  };
};
export default connect(mapState, actionCreators)(DetailProductInfo);
